/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SessionFrequencyEnum } from './sessionFrequencyEnum';


/**
 * Creates or changes a treatment plan. Expects the patient in the context.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PatchedTreatmentPlanWrite { 
    appointment?: number | null;
    collaboardLinkId?: string;
    therapyGoals?: string;
    plannedProcedures?: string;
    prognosis?: string;
    notes?: string;
    patientAgreements?: string;
    plannedSessionCount?: number | null;
    sessionFrequency?: SessionFrequencyEnum | null;
    sessionFrequencyOther?: string;
}
export namespace PatchedTreatmentPlanWrite {
}

export const PatchedTreatmentPlanWrite_appointment_Validators: ValidatorFn[] =
    [ ];

export const PatchedTreatmentPlanWrite_collaboardLinkId_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const PatchedTreatmentPlanWrite_therapyGoals_Validators: ValidatorFn[] =
    [ ];

export const PatchedTreatmentPlanWrite_plannedProcedures_Validators: ValidatorFn[] =
    [ ];

export const PatchedTreatmentPlanWrite_prognosis_Validators: ValidatorFn[] =
    [ ];

export const PatchedTreatmentPlanWrite_notes_Validators: ValidatorFn[] =
    [ ];

export const PatchedTreatmentPlanWrite_patientAgreements_Validators: ValidatorFn[] =
    [ ];

export const PatchedTreatmentPlanWrite_plannedSessionCount_Validators: ValidatorFn[] =
    [  Validators.min(1), Validators.max(32767),];

export const PatchedTreatmentPlanWrite_sessionFrequency_Validators: ValidatorFn[] =
    [ ];

export const PatchedTreatmentPlanWrite_sessionFrequencyOther_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];


